import React, { Fragment } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Wellness = () => {

    return (
        <Fragment>
            <Header />
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Wellness</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="/">Home</a></li>
                                <li>Wellness</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section class="space">
                <div class="container">
                    <div class="row align-items-center sprituality-box">
                        <div class="col-lg-12">
                            <div class="about-content sprituality-content text-center">
                                <div class="title-area">
                                    <span class="sec-subtitle">Take care of yourself without calling it a break</span>
                                    <h2 class="sec-title h1">Feel Better. Slowly.</h2>
                                    <p class="sec-text">Wellness doesn`t have to be complicated. It can be a quiet walk, a good meal, a massage that helps your body let go, or just a few days of sleeping well and eating clean. Our wellness journeys are about slowing down, tuning in, and letting your body and mind reset — gently, and without pressure.</p>
                                    <p class="sec-text">There`s no hard routine or long checklist. Just simple practices, fresh food, nature, and people who genuinely care about your wellbeing.</p>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="image-box1">
                                <img class="img1" src="assets/img/added/wellness-1.png" alt="image1" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content sprituality-content">
                                <div class="title-area">
                                    <p class="sec-text"><b>What to Expect</b></p>
                                    <p class="sec-text">We visit places that focus on real, grounded wellness not fancy spas or trendy detox plans. These are local Ayurvedic centers, small wellness stays, and quiet farm spaces where the healing is natural and rooted in tradition.</p>
                                    <p class="sec-text">You might experience an oil massage, a herbal steam, a slow yoga class, or just time to sit quietly in a garden after a good meal. Some places offer personalized consultations, others are more open and you can decide what works for you.</p>
                                </div>
                                <p class="sec-text"><b>Who Is This For?</b></p>
                                <ul class="about-list1">
                                    <li>People who feel tired, unbalanced, or simply overstimulated</li>
                                    <li>Anyone wanting to gently reset their lifestyle or habits</li>
                                    <li>Travelers curious about Ayurveda or natural healing</li>
                                    <li>Those looking for care not a “fix”</li>
                                </ul>
                                <a href="destination" class="vs-btn style4">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

           
            <Footer />
        </Fragment>
    );
}

export default Wellness;